import React, { useEffect, useState } from "react";
import { ScrollView, View } from "react-native";
import { fp, hp, spV, wp } from "utils/normalise";
import { router, useGlobalSearchParams, useLocalSearchParams, useSegments } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Buttons from "components/Buttons";
import CheckoutPopUpCard from "components/checkout/CheckoutPopUpCard";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import { trackV2 } from "utils/Segment";

export default React.forwardRef(({}, ref) => {
    const [isShown, setIsShown] = useState(false);
    const [isVanish, setIsVanish] = useState(false);
    const [showCartData, setShowCartData] = useState([]);
    const cart = useSelector((state) => state.CartReducer.cart);
    const countrySymbol = useSelector((state) => state.StoredutilsSlice.countrySymbol);

    const local = useGlobalSearchParams();


    const gender = local?.gender || 'female'

    const segments = useSegments();

    const dispatch = useDispatch();

    React.useImperativeHandle(
        ref,
        () => ({
            show,
            hide,
        }),
        []
    );

    useEffect(() => {
        if (isShown && isVanish) {
            setTimeout(() => {
                hide();
            }, 4000);
        }
    }, [isVanish, isShown]);

    const show = (showCartData = [], isVanish = false) => {
        setShowCartData(showCartData);
        setIsVanish(isVanish);
        setIsShown(true);
    };

    const hide = () => {
        setIsShown(false);
        setIsVanish(false);
        setShowCartData([]);
    };

    if (Array.isArray(showCartData) && showCartData?.length > 0) {
        return (
            <>
                <View
                    style={{
                        position: "absolute",
                        top: hp(100),
                        right: wp(30),
                        shadowColor: "rgba(0, 0, 0, 0.25)",
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.4,
                        shadowRadius: 4,
                        backgroundColor: "#fff",
                        zIndex: 999,
                        width: wp(310),
                        padding: wp(16),
                    }}
                >
                    {Array.isArray(showCartData) &&
                        showCartData?.map((o, idx) => (
                            <CheckoutPopUpCard
                                key={idx}
                                isInPopUp={true}
                                hideOptions={true}
                                hideCross={true}
                                cartItem={o}
                                gender={gender}
                            />
                        ))}
                    <View
                        style={{
                            paddingTop: wp(16),
                        }}
                    >
                        <Buttons
                            onPress={() => {
                                hide();
                                router.push(`${gender == 'men' ? '/men' : ''}/checkout`);
                            }}
                            containerStyle={{
                                height: hp(44),
                            }}
                            text="Checkout"
                        />
                    </View>
                </View>
            </>
        );
    }

    if (isShown && cart && cart?.cart && Array.isArray(cart?.cart) && cart?.cart?.length > 0) {
        return (
            <>
                <View
                    style={{
                        position: "absolute",
                        top: hp(100),
                        right: wp(30),
                        shadowColor: "rgba(0, 0, 0, 0.25)",
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.4,
                        shadowRadius: 4,
                        backgroundColor: "#fff",
                        zIndex: 999,
                        width: wp(310),
                    }}
                >
                    <ScrollView
                        style={{
                            maxHeight: hp(450),
                        }}
                        contentContainerStyle={{
                            padding: wp(16),
                        }}
                    >
                        {Array.isArray(cart?.cart) &&
                            cart?.cart?.map((o, idx) => (
                                <CheckoutPopUpCard gender={gender} key={idx} isInPopUp={true} cartItem={o} />
                            ))}
                    </ScrollView>
                    <View
                        style={{
                            padding: wp(16),
                            paddingTop: 0,
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                paddingBottom: 5,
                            }}
                        >
                            <VText
                                style={{
                                    fontSize: fp(12),
                                    fontWeight: "550",
                                }}
                                text={"Estimated Total"}
                            />
                            <VText
                                style={{
                                    fontSize: fp(12),
                                    fontWeight: "550",
                                    marginBottom: spV(10),
                                }}
                                text={`${countrySymbol}${getFormatedCurrency(cart?.orderSummary?.totalAmount)}`}
                            />
                        </View>
                        <Buttons
                            onPress={() => {
                                hide();
                                const eventData = {
                                    products_count: cart?.cart?.length,
                                    total_cart_value: cart?.orderSummary?.totalAmount,
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.PROCEED_TO_CHECKOUT, eventData);
                                router.push(`${gender == 'men' ? '/men' : ''}/checkout`);
                            }}
                            containerStyle={{
                                height: hp(44),
                            }}
                            text="Checkout"
                        />
                    </View>
                </View>
            </>
        );
    }
});
